module.exports = __webpack_public_path__ + "media/images/top/common/img_solution02-86621c2618bfd40bb56f13ddecb451da.png";